import { Component, DestroyRef, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AsyncPipe, isPlatformBrowser, NgClass, NgOptimizedImage } from '@angular/common';
import { RouterLink, RouterModule } from '@angular/router';
import { NotificationsService } from 'src/app/core/services/notifications.service';
import { NotificationsComponent } from 'src/app/core/components/notifications/notifications.component';
import { SearchService } from 'src/app/shared/services/search.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchResultsComponent } from 'src/app/core/components/search-results/search-results.component';
import { debounceTime, fromEvent, map, Observable } from 'rxjs';
import { NotificationState } from 'src/app/shared/store/states/notifications/notification.state';
import { Store } from '@ngxs/store';
import { AnalyticsService } from 'src/app/core/services/analytics.service';
import { AnalyticsEventName } from 'src/app/core/enums/analytics.enum';
import { TranslocoPipe } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navigation',
  imports: [
    NgOptimizedImage,
    NotificationsComponent,
    RouterModule,
    RouterLink,
    AsyncPipe,
    ReactiveFormsModule,
    FormsModule,
    SearchResultsComponent,
    NgClass,
    TranslocoPipe
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent implements OnInit {
  private readonly analyticsService = inject(AnalyticsService);
  private readonly searchService = inject(SearchService);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);
  protected readonly store = inject(Store);
  protected readonly notificationsService = inject(NotificationsService);

  protected readonly searchTerm$ = this.searchService.searchTerm$;

  protected readonly hasUnreadNotifications$: Observable<boolean> =
    this.store.select(NotificationState.getNotifications).pipe(
      map(notifications => notifications.some(n => !n.isRead))
    );
  
  protected readonly jcbPortal = environment.jcbPortal;

  protected isMenuOpen = false;
  protected isSearchOpen = false;

  protected toggleButton(): void {
    if (this.isSearchOpen) {
      this.isSearchOpen = false;
    } else {
      this.isMenuOpen = !this.isMenuOpen;
    }

  }

  protected toggleSearch(): void {
    this.isSearchOpen = !this.isSearchOpen;
  }

  protected handleFeedbackClick(): void {
    this.analyticsService.trackEvent(AnalyticsEventName.ItemClick, {
      itemName: 'feedback_button',
      itemId: 'feedback_button'
    });
  }

  ngOnInit(){
    if (isPlatformBrowser(this.platformId)) {
      fromEvent(window, 'resize').pipe(
        map(() => {
          this.isMenuOpen = false;
        }),
        takeUntilDestroyed(this.destroyRef),
        debounceTime(300),
      ).subscribe();
    }
  }
}
